/**
 * boolFilter.js
 *
 * Defines boolean filter options for use in filter dropdowns.
 * Used to filter data by "Yes" (true) or "No" (false) values.
 */

export default [
  {
    name: 'Yes',
    value: true,
  },
  {
    name: 'No',
    value: false,
  },
];
